<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>TUTOR RESPONSABILE</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <div class="vx-card__body">
          <vs-row>
            <vs-col vs-w="12">
              <vs-input required v-model="form.name" label="Nome" class="w-full"/>
            </vs-col>
            <vs-col vs-w="12" class="mt-5">
              <vs-input required v-model="form.surname" label="Cognome" class="w-full"/>
            </vs-col>
            <vs-col vs-w="8" class="mt-5">
              <vs-input label="Email" type="email" class="w-full" required v-model="form.email"/>
            </vs-col>
            <vs-col vs-w="4" class="mt-5">
              <vs-input label="Max Tirocini" disabled class="w-full" required v-model="form.max_tirocini"/>
            </vs-col>
          </vs-row>
        </div>
        <div class="vx-card__footer">
          <vs-row vs-type="flex" vs-justify="space-around">
            <vs-button @click.prevent="$emit('close')" icon-pack="feather" icon="icon-trash" color="danger" type="line" align="right">Elimina</vs-button>
            <vs-button @click="save" button="submit" :disabled="is_saving" type="line" color="success" icon-pack="feather" icon="icon-save">Salva</vs-button>
          </vs-row>
        </div>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  props: ['selected'],
  data () {
    return {
      is_saving: null,
      form: _.clone(this.selected) || {max_tirocini:40},
    }
  },
  created() {
  },
  methods: {
    save() {
      this.is_saving = true
      this.$http.post('tirocinio/tutor?id='+(this.form.id||''), this.form).then(res => {
        this.$emit('saved')
        this.$emit('close')
      }).finally(res => {
        this.is_saving = false
      })
    },

    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
  }
}
</script>

<style lang="scss">
.select-comp * {
  text-transform: uppercase;
}
</style>
